import React from "react";
import styled from "styled-components/macro";
import { connect } from "react-redux";
import { getItemAlcoholLevel } from "../../features/commerce/selectors";
import { Image } from "../../components/Image";
import { Div } from "../../components/grid";
import { BsCheckSquare, BsSquare } from "../../components/Icons";
import {
  getAcceptAlkhol,
  setAcceptAlkohol,
  getSubmitAlkoholError,
  setSubmitAlcoholError,
} from "../../features/user";

const Webbanner = styled(Div)`
  width: calc(100% - 6px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
  margin-top: -15px;
  padding-top: 15px;
  border: 3px solid ${({ theme }) => theme.colors.colorGreyLight};
  border-top: 10px solid ${({ theme }) => theme.colors.colorGreyLight};
  border-bottom: 0;
`;
const CheckBoxComponentNoStyle = ({
  checked,
  error,
  onClick,
  children,
  ...otherProps
}) => {
  console.log("What is the checkled?", checked);
  return (
    <Div onClick={onClick} {...otherProps}>
      <div className="icon">{checked ? <BsCheckSquare /> : <BsSquare />}</div>
      <div>{children}</div>
    </Div>
  );
};
const CheckBoxComponent = styled(CheckBoxComponentNoStyle)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 15px;
  width: calc(100% - 30px);
  font-size: 16px;
  font-weight: bold;
  line-height: 1.5;

  & > .icon {
    display: flex;
    font-size: 30px;
  }

  ${({ checked, error, theme }) => {
    if (checked) {
      return `
        color: ${theme.colors.colorGreen};
      `;
    }
    if (error) {
      return `
        color: ${theme.colors.colorRed};
      `;
    }
    return `
      color: ${theme.colors.colorGreyDark};
    `;
  }}
`;

const AlkoholWebbannerGodkend = ({
  alcoholLevel,
  setAcceptAlkohol,
  acceptAlkhol,
  onResetSubmitError,
  submitError,
}) => {
  if (alcoholLevel !== "NONE") {
    console.log("Does it have submitError?", submitError);
    const checked = acceptAlkhol !== false && acceptAlkhol >= alcoholLevel;
    return (
      <Webbanner>
        <Image
          imageWidth="180px"
          name="alkohol-webbanner.sst-alkohol-400x400.png"
        />
        <CheckBoxComponent
          error={submitError}
          checked={acceptAlkhol}
          onClick={() => {
            if (submitError) {
              onResetSubmitError();
            }
            setAcceptAlkohol(checked ? false : alcoholLevel);
          }}
        >
          Jeg bekræfter, at jeg er fyldt {alcoholLevel} år.
        </CheckBoxComponent>
      </Webbanner>
    );
  }
  return null;
};

export default connect(
  (state) => ({
    alcoholLevel: getItemAlcoholLevel(state),
    acceptAlkhol: getAcceptAlkhol(state),
    submitError: getSubmitAlkoholError(state),
  }),
  (dispatch) => ({
    setAcceptAlkohol: (acceptAlkhol) =>
      dispatch(setAcceptAlkohol(acceptAlkhol)),
    onResetSubmitError: () => dispatch(setSubmitAlcoholError(false)),
  })
)(AlkoholWebbannerGodkend);
